module.exports = __webpack_public_path__ + "static/media/biteship-shopee.2df4cc41.png";